export const zIndex = (value: number) => `
    z-index: ${value};
`;
export const zIndex = (value: number) => `
    z-index: ${value};
`;
